import React, { useEffect, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import { Link, useNavigate } from "react-router-dom";
import PaginationComponent from "../../../Components/PaginationComponent";
import toast from "react-hot-toast";
import medicalServices from "../../../Services/medicalServices";

const MedicalServices = () => {
  const [searchData, setSearchData] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [paginatedData, setPaginatedData] = useState([]);
  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [patients, setPatients] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const getStock = async () => {
      try {
        setLoading(true);
        const response = await medicalServices.fetchAll();
        setPatients(response.services);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        toast.error("Error fetching Medical Services");
      }
    };
    getStock();
  }, []);

  useEffect(() => {
    const filteredResult =
      patients?.filter((item) =>
        item?.name?.toLowerCase().includes(searchData.toLowerCase())
      ) || [];
    setFilteredData(filteredResult);
    setCurrentPage(1);
  }, [searchData, patients]);

  useEffect(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    setPaginatedData(filteredData?.slice(startIndex, endIndex) || []);
  }, [currentPage, filteredData]);

  return (
    <div className="p-3 sm:p-6">

      <div className="bg-white border border-gray-200 rounded-xl px-4 sm:px-6 py-4 mb-4 sm:mb-5 shadow-sm">

     <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 mb-3">

  <div>
    <h1 className="text-[15px] sm:text-[17px] font-[500] text-gray-800 leading-tight">
      Medical Services
    </h1>
    <p className="text-[11px] sm:text-[12px] text-gray-400 mt-0.5">
      {filteredData?.length || 0} records found
    </p>
  </div>

  <div className="flex items-center gap-2 w-full sm:w-auto">

    <div className="relative flex-1 sm:flex-none">
      <SearchIcon
        className="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400"
        style={{ fontSize: 16 }}
      />
      <input
        type="search"
        placeholder="Search by name..."
        value={searchData}
        onChange={(e) => setSearchData(e.target.value)}
        className="pl-8 pr-3 py-[7px] w-full sm:w-[230px] text-[13px] bg-gray-50 border border-gray-200 rounded-lg focus:outline-none focus:ring-1 focus:ring-[#2F6DB4]/30"
      />
    </div>

    <Link to="saleservice" className="flex-shrink-0">
      <button className="whitespace-nowrap bg-[#2F6DB4] text-white text-[12px] sm:text-[13px] font-[500] px-3 sm:px-4 py-2 rounded-lg shadow-md hover:shadow-gray-200 hover:scale-[1.03] active:scale-[0.97] transition-all duration-300">
        + Medical Service
      </button>
    </Link>

  </div>
</div>

      </div>

      <div className="hidden sm:block bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
        <div className="overflow-x-auto">
          <table className="w-full min-w-[400px]">
            <thead>
              <tr className="bg-[#2F6DB4] text-[11px] uppercase text-white">
                <th className="py-3 px-4 text-left">Service ID</th>
                <th className="py-3 px-4 text-left">Medical Service</th>
                <th className="py-3 px-4 text-center">Price</th>
                <th className="py-3 px-4 text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan={4} className="py-10 text-center text-gray-400 text-[13px]">Loading...</td>
                </tr>
              ) : paginatedData?.length === 0 ? (
                <tr>
                  <td colSpan={4} className="py-10 text-center text-gray-400 text-[13px]">No records found</td>
                </tr>
              ) : (
                paginatedData?.map((patient) => (
                  <tr key={patient?.id} className="border-t hover:bg-gray-50 text-[13px]">
                    <td className="py-3 px-4 text-gray-500">{patient?.id}</td>
                    <td className="py-3 px-4 font-[500] text-gray-800">{patient?.name}</td>
                    <td className="py-3 px-4 text-center text-gray-600">{patient?.price}</td>
                    <td className="py-3 px-4 text-center">
                      <button
                        onClick={() => navigate(`saleservice/${patient.id}`)}
                        className="bg-blue-50 text-blue-600 text-[12px] px-3 py-1 rounded-md hover:bg-blue-100 transition-colors"
                      >
                        Update
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className="sm:hidden space-y-2.5">
        {loading ? (
          <div className="bg-white border border-gray-200 rounded-xl py-10 text-center text-gray-400 text-[13px] shadow-sm">
            Loading...
          </div>
        ) : paginatedData?.length === 0 ? (
          <div className="bg-white border border-gray-200 rounded-xl py-10 text-center text-gray-400 text-[13px] shadow-sm">
            No records found
          </div>
        ) : (
          paginatedData?.map((patient) => (
            <div
              key={patient?.id}
              className="bg-white border border-gray-200 rounded-xl px-4 py-3.5 shadow-sm"
            >
              <div className="flex items-center justify-between mb-2">
                <span className="text-[10px] font-bold text-[#2F6DB4] uppercase tracking-wide">
                  ID #{patient?.id}
                </span>
                <button
                  onClick={() => navigate(`saleservice/${patient.id}`)}
                  className="bg-blue-50 text-blue-600 text-[11px] font-[500] px-3 py-1 rounded-md hover:bg-blue-100 active:scale-95 transition-all"
                >
                  Update
                </button>
              </div>

              <p className="text-[14px] font-[600] text-gray-800 leading-tight truncate mb-2">
                {patient?.name}
              </p>

              <div className="flex items-center justify-between bg-gray-50 border border-gray-100 rounded-lg px-3 py-2">
                <span className="text-[11px] text-gray-400 uppercase tracking-wide font-[500]">Price</span>
                <span className="text-[13px] font-[700] text-gray-700">{patient?.price}</span>
              </div>
            </div>
          ))
        )}
      </div>

      <PaginationComponent
        filteredData={filteredData}
        setPaginatedData={setPaginatedData}
        itemsPerPage={itemsPerPage}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
      />
    </div>
  );
};

export default MedicalServices;